// extracted by mini-css-extract-plugin
export default {"background":"modal_background__e2CWC"};